function zoom() {
	var img = $(".zoom .slick-active img");
	var widthStart = img.width();
	var heightStart = img.height();
	var width = widthStart;
	var height = heightStart;

	$(document).on('click', '#increase', function() {
		img.addClass('no-max-width');
		img.removeClass('min-height');
	    img.width(width * 1.2);
        img.height(height * 1.2);
        width *= 1.2;
        height *= 1.2;
	});

	$(document).on('click', '#decrease', function() {
		img.addClass('no-max-width');
		img.addClass('min-height');
	    img.width(width / 1.2);
        img.height(height / 1.2);
        width /= 1.2;
        height /= 1.2;
        if (width < widthStart) {
        	width = widthStart;
	    	img.width(widthStart);
        }
	});

	//- скрипт установки полного разрешения картинки
	// $(document).on('click', '#full', function() {
	// 	img.removeClass('no-max-width');
	// 	img.removeClass('min-height');
	// 	width = widthStart;
	// 	height = heightStart;
	//     img.width(widthStart);
    //     img.height(heightStart);
	// });
}

$(document).ready(function () {

	zoom();

	$(".zoom").on("afterChange", function (){
		zoom();
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/one-exponat/exponat-zoom.js